import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  class: "gap-20",
  style: {"flex":"1","overflow":"auto","display":"grid"}
}
const _hoisted_2 = { class: "cm-align-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "cm-align-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["innerHTML"]

import { getSvgIconDataUrl } from '@/utils/svg-icon-data-url'

import { TerminalIconRound } from '@/views/dashboard/_enum/terminal-icon-round';
import DescribeItem from './describe-item.vue';
import { SensitiveWordsFileOutgoingResponse } from '../service';
import { PropType, computed } from 'vue';
import { ApplyState, fileType, getApprovalChannelI18nKey } from '../types/approval-terminal-file-outsourcing';
import { bytesToSize, highLightKeywords } from '@/utils/tool';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListApproval',
  props: {
  list: {
    type: Array as PropType<SensitiveWordsFileOutgoingResponse[]>,
    required: true,
    default: () => []
  }
},
  setup(__props) {

const { t, locale } = useI18n()



const channelLabel = (val: string) => {
  const key = getApprovalChannelI18nKey(val)
  return key ? t(key) : val || '--'
}

const mainList = computed(() => {
  void locale.value
  return [
    {
      allowEmpty: true,
      colOpt: { span: 8 },
      titleKey: 'computer_name',
      describeListByType: [
        { label: t('approvalTerminalFileOutsourcing.lblGroup'), prop: 'group_name' },
        { label: t('approvalTerminalFileOutsourcing.lblUserMark'), prop: 'user_mark' },
        { label: t('approvalTerminalFileOutsourcing.lblMac'), prop: 'mac', formatter: (val) => val || '--' },
        { label: t('approvalTerminalFileOutsourcing.lblIp'), prop: 'system_ip', type: 'IP' },
      ]
    },
    {
      allowEmpty: true,
      colOpt: { span: 8 },
      titleKey: 'ext',
      describeListByType: [
        { label: t('approvalTerminalFileOutsourcing.lblFileType'), prop: 'ext', formatter: (val) => val || '--' },
        { label: t('approvalTerminalFileOutsourcing.lblFileSize'), prop: 'size', formatter: (val) => bytesToSize(val) },
        { label: t('approvalTerminalFileOutsourcing.lblSensitiveHit'), prop: 'keyword', type: 'keyword' },
        { label: t('approvalTerminalFileOutsourcing.lblPath'), prop: 'file_path' },
      ]
    },
    {
      colOpt: { span: 7 },
      titleKey: '',
      describeListByType: (data: SensitiveWordsFileOutgoingResponse) => [
        { label: t('approvalTerminalFileOutsourcing.lblStrategy'), prop: 'strategy_name', allowEmpty: true, formatter: (val) => val || '--' },
        { label: t('approvalTerminalFileOutsourcing.lblOutboundMethod'), prop: 'soft_name', formatter: (val) => channelLabel(val) },
        { label: t('approvalTerminalFileOutsourcing.lblProcess'), prop: 'process_name', allowEmpty: true, formatter: (val) => val || '--' },
        { label: t('approvalTerminalFileOutsourcing.lblApplyReason'), prop: 'apply_reason', formatter: (val) => val || '--', allowEmpty: true },
        { label: t('approvalTerminalFileOutsourcing.lblRejectReason'), prop: 'reason', formatter: (val) => val || '--', show: () => data.apply_state === ApplyState.Rejected },
      ]
    }
  ]
})

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.list.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.list, (row) => {
          return (_openBlock(), _createBlock(DescribeItem, {
            data: row,
            mainList: mainList.value,
            key: row.id,
            colOpt: { style: { 'margin-right': '10px', width: '100px', flex: '0 0 auto' } },
            valColOpt: {style: 'flex: 1'}
          }, {
            computer_name: _withCtx(({ val, item }: { val: string, item: SensitiveWordsFileOutgoingResponse }) => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  class: "terminal-icon",
                  style: {"width":"20px","height":"20px","margin-right":"10px"},
                  src: _unref(TerminalIconRound)[item.system_type][item.login_status || 4] ?? '../assets/out.svg',
                  alt: ""
                }, null, 8, _hoisted_3),
                _createElementVNode("div", null, _toDisplayString(val), 1)
              ])
            ]),
            ext: _withCtx(({ item }: { item: SensitiveWordsFileOutgoingResponse }) => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: _unref(fileType).includes(item.ext) ? _unref(getSvgIconDataUrl)(`views/dashboard/data-safe/anti-external-control/assets/fileType/${item.ext}`) : require(`../assets/file.png`),
                  width: "20",
                  height: "20",
                  style: {"margin-right":"10px"},
                  alt: ""
                }, null, 8, _hoisted_5),
                _createElementVNode("div", {
                  innerHTML: _unref(highLightKeywords)(item.file_name, item.keyword + ''),
                  class: "cm-ellipsis-line-one"
                }, null, 8, _hoisted_6)
              ])
            ]),
            "header-right": _withCtx(({ row }) => [
              _renderSlot(_ctx.$slots, "header-right", { row: row })
            ]),
            _: 2
          }, 1032, ["data", "mainList"]))
        }), 128))
      : (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          style: {"margin-top":"20vh"},
          "image-size": 250,
          image: _unref(getSvgIconDataUrl)(_ctx.EMPTY_TABLE_SVG_ICON),
          description: _unref(t)('approvalTerminalFileOutsourcing.emptyList')
        }, null, 8, ["image", "description"]))
  ]))
}
}

})